export type User = {
    id: string;
    login: string;
    name: string;
    email: string;
    isSubscriptionOwner: boolean;
    hasEntitlementsRole: boolean;
    hasSupportRole: boolean;
    isAdminReadOnly: boolean;
};

type UserApiResponse = {
    user?: Partial<User>;
};

export type UserResponse = User | null;

export const userQuery = {
    query: (userId: string) => ({
        url: `/api/1/users/${userId}`,
        method: 'get',
    }),
    transformResponse: (response: UserApiResponse): UserResponse => {
        const { user } = response;
        if (!user) return null;

        return {
            id: user.id ?? '',
            login: user.login ?? '',
            name: user.name ?? '',
            email: user.email ?? '',
            isSubscriptionOwner: user.isSubscriptionOwner ?? false,
            hasEntitlementsRole: user.hasEntitlementsRole ?? false,
            hasSupportRole: user.hasSupportRole ?? false,
            isAdminReadOnly: user.isAdminReadOnly ?? false,
        };
    },
};
